import Vue from 'vue'
import App from './App'

// Vuex
import Vuex from 'vuex'
import store from './store' // 确保你有 store/index.js 文件

// Element-UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 路由
import router from './router'

// axios
import axios from './api'
Vue.prototype.http = axios

// swiper
import 'swiper/dist/css/swiper.min.css'

// 重置样式
import './assets/css/reset.min.css'

// jquery
import 'jquery'

// bootstrap
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

// animate.css
import 'animate.css'

// 全局组件
import Header from './components/Header'
Vue.component(Header.name, Header)

import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

// 使用插件
Vue.use(Vuex)
Vue.use(ElementUI)

// 禁止生产提示
Vue.config.productionTip = false

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 创建 Vue 实例（只能有一个）
new Vue({
  store, // 注入 Vuex store
  router, // 注入路由
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js